/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBiomarkerDto
 */
export interface UpdateBiomarkerDto {
    /**
     * Date of the biomarker measurement
     * @type {Date}
     * @memberof UpdateBiomarkerDto
     */
    date?: Date;
    /**
     * Name of the biomarker
     * @type {string}
     * @memberof UpdateBiomarkerDto
     */
    name?: string;
    /**
     * Value of the biomarker
     * @type {string}
     * @memberof UpdateBiomarkerDto
     */
    value?: string;
    /**
     * Reference range for the biomarker
     * @type {string}
     * @memberof UpdateBiomarkerDto
     */
    referenceRange?: string;
    /**
     * Unit of measurement
     * @type {string}
     * @memberof UpdateBiomarkerDto
     */
    unit?: string;
    /**
     * Whether the value is out of range
     * @type {boolean}
     * @memberof UpdateBiomarkerDto
     */
    outOfRange?: boolean;
}

/**
 * Check if a given object implements the UpdateBiomarkerDto interface.
 */
export function instanceOfUpdateBiomarkerDto(value: object): value is UpdateBiomarkerDto {
    return true;
}

export function UpdateBiomarkerDtoFromJSON(json: any): UpdateBiomarkerDto {
    return UpdateBiomarkerDtoFromJSONTyped(json, false);
}

export function UpdateBiomarkerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBiomarkerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'] == null ? undefined : json['value'],
        'referenceRange': json['referenceRange'] == null ? undefined : json['referenceRange'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'outOfRange': json['outOfRange'] == null ? undefined : json['outOfRange'],
    };
}

export function UpdateBiomarkerDtoToJSON(json: any): UpdateBiomarkerDto {
    return UpdateBiomarkerDtoToJSONTyped(json, false);
}

export function UpdateBiomarkerDtoToJSONTyped(value?: UpdateBiomarkerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? undefined : ((value['date']).toISOString()),
        'name': value['name'],
        'value': value['value'],
        'referenceRange': value['referenceRange'],
        'unit': value['unit'],
        'outOfRange': value['outOfRange'],
    };
}

